export default __webpack_public_path__ + "static/media/NA.67fb9f75.svg";